import { motion } from 'framer-motion';

const testimonials = [
  {
    name: 'Scott Robben',
    text: 'Rob did a fantastic job fixing the dings on my suv. Would definitely recommend you reach out to KC PDR for your dent repairs. Great price, very personable people!',
    rating: 5,
  },
  {
    name: "Trey's Lawn & Landscape",
    text: "I've hired KC PDR several times and they always do a great job at a reasonable price. Highly recommend!",
    rating: 5,
  },
  {
    name: 'Nicole Bradfield',
    text: 'Happy with the hail damage repair to our truck. Good price and excellent work. Recommend to all.',
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-bg-soft">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-text-dark mb-4">
            What Our Customers Say
          </h2>
          <p className="font-inter text-lg text-text-muted max-w-2xl mx-auto">
            Real reviews from satisfied customers across Kansas City
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              {/* Quote Icon */}
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full mb-4">
                <i className="ri-double-quotes-l text-2xl text-primary"></i>
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-primary"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="font-inter text-text-muted mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Customer Name */}
              <div className="border-t border-gray-200 pt-4">
                <h4 className="font-montserrat font-semibold text-text-dark">
                  {testimonial.name}
                </h4>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
